var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"category badge badge--small badge--solid"},[_vm._v(" "+_vm._s(_vm.category)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }